var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import dayjs from "dayjs";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { Attachment } from "./Attachment";
export var AdditionalTab = [{
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.Typography,
                name: "",
                columnSize: 12,
                fontWeight: "strong",
                label: "Courier Details",
                labelTypographyProps: {
                    fontSize: "base",
                    fontWeight: "strong",
                    color: "text.primary"
                }
            }, {
                type: FormItemTypes.TextInput,
                name: "CourierName",
                label: "Courier Name",
                placeholder: "E.g. DTC couriers",
                validator: function (value) {
                    var leadingSpacesRegex = /^\S.*$/;
                    if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                        return "Leading spaces are not allowed.";
                    }
                    if ((value === null || value === void 0 ? void 0 : value.length) < 10 || (value === null || value === void 0 ? void 0 : value.length) > 30) {
                        return "courier name can only be of length between 10 and 30";
                    }
                    return undefined;
                }
            }, {
                type: FormItemTypes.TextInput,
                name: "DocketNumber",
                label: "Docket Number",
                placeholder: "E.g. DN-819388",
                validator: function (value) {
                    if (value) {
                        if (!/^[A-Z]+-\d+$/.test(value)) {
                            return "Invalid Docket number! Format should be PREFIX-1234";
                        }
                        else {
                            return "";
                        }
                    }
                }
            }, {
                type: FormItemTypes.DatePicker,
                name: "DispatchDate",
                label: "Dispatch date",
                disableFuture: true,
                placeholder: "E.g. 6jan, 2025",
                valueGetter: function (formValues, field) {
                    var _field$name, _field$name2;
                    return formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : ""]).format("DD MMM, YYYY") : "-";
                }
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "",
        columnSize: 12,
        sx: {
            border: "none",
            borderRadius: "12px",
            marginLeft: "2",
            mb: 9
        },
        elements: __spreadArray([{
                type: FormItemTypes.Typography,
                name: "sub_heading",
                label: "Attachments",
                labelTypographyProps: {
                    fontSize: "base",
                    fontWeight: "strong",
                    color: "text.primary"
                },
                children: "You can attach files in formats such as JPEG, PNG, XLSX, DOCX, MP4, Maximum file should be 5MB.",
                columnSize: true,
                color: "text.tertiary"
            }], Attachment, true)
    }];
